export const shape10 = [
    0, 1, 0, 0, 1,
    0, 0, 1, 1, 0,
    0, 0, 1, 1, 0,
    0, 1, 0, 0, 1,
    0, 0, 0, 0, 0,
]